<template>
  <div>
    <div class="page-header">
      <h1>
        Status for job {{ job_id
        }}<help>
          <template v-slot:title>Job overview help</template>
          <template>
            <p>
              This page shows the progress of the job. A job can be in different
              job states. During the
              <span class="badge badge-info">processing</span> state, the
              identifiers of the submitted sequences will be added to the
              "Analyzing sequences" section and as results are produced, the
              resulttypes will be shown for each sequence. Once the job is
              <span class="badge badge-success">finished</span>, the results for
              each sequence can be browsed with psov2.
            </p>
          </template>
        </help>
      </h1>
    </div>
    <Notification v-model="message"></Notification>
    <div v-if="loading">Loading...</div>
    <div v-if="notFound">Job not found</div>
    <div v-if="jobAvailable">
      <div>
        <ul>
          <li>
            Status:
            <span class="badge" v-bind:class="labelClass">{{
              job.state.label
            }}</span>
          </li>
          <li>
            Created:
            <timeago :datetime="job.created" :auto-update="60"></timeago>
          </li>
          <li>
            Last Updated:
            <timeago :datetime="job.lastUpdated" :auto-update="60"></timeago>
          </li>
          <li>
            Delete at:
            <timeago :datetime="job.deleteAt" :auto-update="60"></timeago>
          </li>
        </ul>
      </div>

      <div>
        <h2 v-if="isProcessing">
          Analyzing sequences
          <b-spinner variant="success" label="Spinning"></b-spinner>
        </h2>
        <h2 v-else>
          Analysis finished
        </h2>

        <ul>
          <li v-for="(list, name) in filetable" :key="name">
            {{ name }}
            <ul>
              <li v-for="file in list" :key="file">
                <a v-bind:href="file.link">{{ file.tool }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Layout from "@/mixins/psov-layout.vue";
import JobMixin from "@/mixins/job.vue";
import Help from "@/components/Help.vue";

export default {
  name: "Progress",
  mixins: [Layout, JobMixin],
  components: { Help },
  data: function() {
    return {
      loading: true,
      notFound: false
    };
  },
  methods: {
    getFiles: function(job, type) {
      return job.data.files.filter(f => f.type === type);
    }
  },
  computed: {
    labelClass: function() {
      return {
        "badge-info":
          this.job.state.value !== "Failed" &&
          this.job.state.value !== "Succeeded",
        "badge-danger": this.job.state.value === "Failed",
        "badge-success": this.job.state.value === "Succeeded"
      };
    },
    isError() {
      return this.job !== null && this.job.state.value === "Failed";
    },
    isSuccess() {
      return this.job !== null && this.job.state.value === "Succeeded";
    },
    isProcessing() {
      return this.job !== null && this.job.state.value === "Processing";
    },
    isElse() {
      return !this.isError || !this.isSuccess;
    },
    jobAvailable() {
      return this.job !== null;
    },
    fileList() {
      return JSON.stringify(this.job.data.files, null, 2);
    },
    resultFiles() {
      if (this.job !== null) {
        return this.getFiles(this.job, "result");
      } else {
        return [];
      }
    },
    filetable() {
      let vm = this;
      if (this.job !== null) {
        // find all job results and covert them into the format {'name': '', 'tool':'', 'file':'', 'link':''}
        let jobs = this.job.data.files
          .filter(f => f.type.match(/result/i))
          .map(function(f) {
            if (f.type === "result") {
              let seq_id = f.name.replace(".json", "");
              return [
                {
                  name: seq_id,
                  tool: "final result (psov2)",
                  file: f,
                  link: vm.$router.resolve({
                    name: "seq-details",
                    params: { job_id: vm.job_id, seq_id: seq_id }
                  }).href
                }
              ];
            } else {
              let x = f.name.match(/(.+)\.(.*)\.json/);
              return {
                name: x[1],
                tool: x[2],
                file: f,
                link: vm.$router.resolve({
                  name: "seq-details",
                  params: { job_id: vm.job_id, seq_id: x[1] }
                }).href
              };
            }
          })
          .flat();

        // group the results
        let grouped = jobs.reduce((res, obj) => {
          if (res[obj.name]) {
            res[obj.name].push(obj);
          } else {
            res[obj.name] = [obj];
          }
          return res;
        }, {});

        // build table

        return grouped;
      } else {
        return [];
      }
    }
  },
  watch: {
    isSuccess: function(val) {
      if (val) {
        if (this.resultFiles.length > 1) {
          // multiple files
          // show filenames
          // show file overview
        } else if (this.resultFiles.lenght == 0) {
          let file = this.resultFiles[0];
          let x = file.name.match(/(.+)\.(.*)\.json/);
          let url = this.$router.resolve({
            name: "seq-details",
            params: { job_id: this.job_id, seq_id: x[1] }
          }).href;
          // only one file
          // redirect to psov
          window.location.href = url;
        } else {
          // no result file
        }
      }
    }
  }
};
</script>
